export default {
    "default_negotiations": [
        "self",
        "direct_chief",
        "functional_chief"
    ],
    "stage_negotiations": [],
    "on_disagree_go_to_self_negotiation": false,
    "types": {
        "self": {
            "showName": "Сотрудник"
        },
        "direct_chief": {
            "showName": "Функциональный руководитель"
        },
        "direct_senior_chief": {
            "showName": "Вышестоящий"
        },
        "direct_senior_1_chief": {
            "showName": "Вышестоящий +1"
        },
        "direct_senior_2_chief": {
            "showName": "Вышестоящий +2"
        },
        "direct_senior_3_chief": {
            "showName": "Вышестоящий +3"
        },
        "direct_senior_4_chief": {
            "showName": "Вышестоящий +4"
        },
        "direct_senior_5_chief": {
            "showName": "Вышестоящий +5"
        },
        "functional_chief": {
            "showName": "Командный руководитель"
        },
        "hr_chief": {
            "showName": "HR BP"
        },
        "hr_bs_chief": {
            "showName": "HR BP вертикали"
        },
        "gm_chief": {
            "showName": "GM"
        },
        "head_chief": {
            "showName": "Директор департамента"
        },
        "other": {
            "showName": "Ручной"
        }
    }
}